export const SET_ADDRESS = 'SET_ADDRESS'

export const setAddress= (address: string) => (dispatch: any) => {
  dispatch({
    type: SET_ADDRESS,
    address
  })
}
